import { get } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  getRatingsOptions: async () => {
    const options = { url: apiEndpoints.ratingsOptions };
    return get(options);
  },
};
